import React, { Component } from 'react';
import { connect } from 'react-redux';
import ClientModalView from './ClientModal.view';

export class ClientModalContainer extends Component {

  constructor(props){
    super(props);

    this.updateClientTrustStatus = this.updateClientTrustStatus.bind(this);
    this.updateClientRedeemStatus = this.updateClientRedeemStatus.bind(this);
  }

  componentDidMount() {
    const { dispatch, username } = this.props;
    if(username){
      dispatch({
        $global: true,
        type: 'FETCH_CLIENT_DATA_AND_TRADES',
        payload: {
          username,
        },
      });
    }
  }

  updateClientTrustStatus(statusAction, username){
    const { dispatch } = this.props;
    dispatch({
      $global: true,
      type: 'UPDATE_CLIENT_TRUST_STATUS',
      payload: {
        statusAction,
        username,
      }
    });
  }

  updateClientRedeemStatus(redeemStatus, username){
    const { dispatch } = this.props;
    dispatch({
      $global: true,
      type: 'UPDATE_CLIENT_REDEEM_STATUS',
      payload: {
        redeemStatus,
        username,
      }
    });
  }

  render() {
    return (<ClientModalView
      {...this.props}
      {...this.state}
      updateClientTrustStatus={this.updateClientTrustStatus}
      updateClientRedeemStatus={this.updateClientRedeemStatus}
    />);
  }

}

function mapStateToProps(state) {
  const { clientTrades, clientData } = state.clientModal;
  return {
    clientTrades: clientTrades,
    client: clientData,
  };
}

export default connect(mapStateToProps)(ClientModalContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientModal.container.js